import React from 'react'

function DemoButton(props) {
  return (
    <a
        onClick={() => {props.setIsDemoPaneOpen(true); props.setIsOnboardOpen(false);}}
        href="#demo-button"
        id="demo-button"
        className="bg-white text-purple-100 hover:bg-grey-100 px-6 py-3 rounded-full font-semibold"
    >
        Demo
    </a>
  )
}

export default DemoButton